export const paintRegionsOptions = [
  { id: 1, label: 'Outlined', value: 'paintBlockOutline' },
  { id: 2, label: 'Filled', value: 'paintBlockFilled' },
];

// defectPermissionVisibility field is used to describe that this specific option is related to read:defects permissions
export const heatmapPropertiesDetails = [
  {
    id: 1,
    label: 'Paint Block',
    value: 'block',
    defectVisibilityPermission: false,
  },
  {
    id: 2,
    label: 'Detailed (Voxel)',
    value: 'voxel',
    defectVisibilityPermission: true,
  },
];
